import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div>
            <h1>The page you're looking for is not available.</h1>
        </div>
    );
};

export default NotFound;